// 调证模块翻译汇总
import recommendation from "./recommendation.js";
import uploadOld from "./uploadOld.js";
import investigation from "./investigation.js";

export default {
  recommendation,
  uploadOld,
  investigation,
};
